// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"d8e71231","433":"30fe07a2","453":"949c8143","561":"9c1481d8","720":"3e046930","752":"7b75fe52","909":"7881fae9","946":"b644a15f","989":"21224394"}[chunkId] + ".chunk.js";
};